import { useParams } from 'react-router-dom';

import { OrganizationAppsPage } from '~/components/pages/OrganizationAppsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationAppsRoute: React.FC = () => {
  const { organizationId } = useParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OrganizationAppsPage organizationId={organizationId} />
    </DashboardTemplate>
  );
};
